import NotificationsTypes from './NotificationsTypes';

export default NotificationsTypes;
